import { Select } from 'antd';
import React from 'react';
import iconAmazon from './../../../../../resources/imgs/amazon.png';
import './styles.css';
import { listChannel } from './../../../../../utils/channel'
import handleException from './../../../../../services/handleException'
import { getImageChannel } from './../../../../../constants/order'
import { alertError } from './../../../../../services/dialog'
import lang from './../../../../../languages/en'

const Option = Select.Option

const data = [{
    key: '1',
    channel: <img className="icon-amazon" src={iconAmazon} />,
    active: 'Yes'
},];

class ChannelTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listChannel: [],
            channelActive: null,
            shortChannel: ''
        };
    }

    componentDidMount() {
        listChannel().then(res => {
            if(res.data.code === 10001) {
                let listChannel = [],
                    channelActive = 1,
                    shortChannel = null
                if(Object.keys(res.data.data).length
                    && res.data.data.channels.length
                    && res.data.data.channels[0]["ID"]) {
                    listChannel = res.data.data.channels
                    channelActive =  listChannel[0]["ID"]
                    shortChannel =  listChannel[0]["ShortName"]
                }
                this.setState({
                    listChannel,
                    channelActive,
                    shortChannel
                })
                this.props.selectChannel(channelActive)
                this.props.shortChannel(shortChannel)
            } else {
                handleException(res)
            }
        }).catch(err => {
            handleException(err)
        })
    }

    onChange = (channel_id) => {
        if(this.props.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if(this.props.isEdit) {
            this.props.popUpConfirmSave().then(res => {
                this.handleOnChange(channel_id)
            })
        } else {
            this.handleOnChange(channel_id)
        }
    }

    handleOnChange = (channel_id) => {
        let shortChannel = null
        this.state.listChannel.map((e, i) => {
            if(e.ID === channel_id) {
                shortChannel = e.ShortName
            }
        })
        this.setState({
            channelActive: channel_id
        })
        shortChannel && this.props.shortChannel(shortChannel)
        this.props.resetCheckbox()
        this.props.selectChannel(channel_id)
    }

    render() {
        return (
            <div id="ChannelTable">
                 <Select
                    style={{ width: '120px' }}
                    onChange={this.onChange}
                    value={this.state.channelActive}
                 >
                    {
                        this.state.listChannel.map((e, i) => e.Name && (
                            <Option
                                key={i}
                                value={e.ID}
                            >
                                {getImageChannel(e.Name)}
                            </Option >
                        ))
                    }
                 </Select>
            </div>
        )
    }
}
export default ChannelTable



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/channel-table/index.js